'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the Second marriage Marathi matrimony in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the most trusted Marathi matrimony for second marriage in Maharashtra.' },
  { question: 'How to search for a second marriage Marathi Vadhu Var Suchak?', answer: 'Visit the MarathiVadhuVarSuchak.com site, which is the official website of the second marriage Marathi Vadhu Var Suchak Mandal in Maharashtra.' },
  { question: 'How to search the second marriage Marathi bride online?', answer: 'To search the second marriage Marathi bride online, you have to register for free through the MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search for the Marathi Divorcee brides online?', answer: 'To search for the Marathi Divorcee brides online, the MarathiVadhuVarSuchak.com site is the most trusted option.' },
  { question: 'Which is the most trusted Marathi divorcee Matrimony in Pune?', answer: 'For Pune-based Vadhu Var, the MarathiVadhuVarSuchak.com site is the most trusted Marathi divorcee Matrimony brand.' },
  { question: 'How to search the Marathi divorcee bride profiles online?', answer: 'MarathiVadhuVarSuchak.com matrimonial site is the trusted choice to search the Marathi divorcee bride profiles online.' },
  { question: 'How to search for Widow Marathi Divorcee Vadhu matrimony profile online?', answer: 'Register free on MarathiVadhuVarSuchak.com to search for widow Marathi Divorcee Vadhu matrimony profile online.' },
  { question: 'How to search the Marathi divorcee brides in Mumbai?', answer: 'Marathi divorcee grooms and brides from Mumbai city are available on MarathiVadhuVarSuchak.com matrimony site.' },
  { question: 'How to do search for second marriage Marathi divorcee Vadhu in Pune?', answer: 'To search Pune-based Marathi divorcee brides, visit the MarathiVadhuVarSuchak.com for free registration.' },
  { question: 'What to do for second marriage Marathi grooms matrimony profiles search?', answer: 'You can search for Marathi grooms matrimony profiles on MarathiVadhuVarSuchak.com matrimonial portal.' },
  { question: 'Where we can search for trusted Marathi divorced grooms matrimony profiles?', answer: 'For trusted Marathi divorced grooms matrimony profiles are available on MarathiVadhuVarSuchak.com matrimonial site.' },
  { question: 'How to search verified divorcee matrimony Marathi grooms online?', answer: 'Download MarathiVadhuVarSuchak.com Marathi matrimonial app for free registration. Then you can search for divorced Marathi grooms online.' },
  { question: 'How to search the Anand Maratha divorcee brides online?', answer: 'To search Maratha divorcee brides online, Maratha divorcee grooms can download MarathiVadhuVarSuchak.com app for free registration.' },
  { question: 'Which is the trusted Marathi divorcee matrimony app in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com matrimony app is the most trusted Marathi divorcee matrimony app in Maharashtra state.' },
  { question: 'How to search the Yog Maratha divorcee brides in Pune?', answer: 'Download the MarathiVadhuVarSuchak.com matrimony app for free registration. After approval you can search Maratha divorcee brides from Pune.' },
  { question: 'How to search the second marriage 45 age 96 Kuli Maratha divorcee brides?', answer: '96 Kuli Maratha grooms can search age wise 96 Kuli Maratha divorcee brides through MarathiVadhuVarSuchak.com matrimony app.' },
  { question: 'How to search Anand Maratha divorcee brides list online?', answer: 'MarathiVadhuVarSuchak.com matrimony app is best option to search Maratha divorcee brides list online.' },
  { question: 'Which is the best divorcee matrimony Marathi in Mumbai?', answer: 'Most trusted MarathiVadhuVarSuchak.com matrimony app is the best Marathi matrimony for divorcee brides and grooms in Mumbai.' },
  { question: 'How to search the Vadhu 45 age 96 Kuli Maratha divorcee brides online?', answer: 'To search age wise 96 Kuli Maratha divorcee brides online, MarathiVadhuVarSuchak.com matrimony app is trusted brand.' },
  { question: 'How to search the verified divorcee Vadhu profile online?', answer: 'To search the verified divorcee Vadhu profile online, download MarathiVadhuVarSuchak.com matrimony app for free registration.' },
  { question: 'How to search verified widow Marathi divorcee Vadhu profiles?', answer: 'You can search verified widow Marathi divorcee Vadhu profiles through MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search for second marriage Marathi divorcee Vadhu online?', answer: 'To search for Marathi divorcee Vadhu online for second marriage, visit trusted MarathiVadhuVarSuchak.com matrimonial site.' },
  { question: 'How to search the verified second marriage Marathi girl matrimony profiles?', answer: "To search the verified Marathi bride's matrimony profiles for second marriage, download MarathiVadhuVarSuchak.com app for registration." },
  { question: 'How to search the second marriage Marathi latest matrimony profiles?', answer: 'To see news profiles every day, MarathiVadhuVarSuchak.com site is the best option in Maharashtra state.' },
  { question: 'Which is the most trusted Marathi Divorced Matrimony in Pune?', answer: 'For Marathi divorcee brides and grooms from Pune region, MarathiVadhuVarSuchak.com app is the trusted brand for free registration.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Second marriage Marathi matrimony" },
  { label: "Second Marriage Marathi" },
  { label: "Second Marriage Marathi bride" },
  { label: "Marathi Divorcee brides" },
  { label: "Marathi Divorcee Matrimony" },
  { label: "Marathi Divorcee Bride" },
  { label: "Widow Marathi Divorcee Vadhu" },
  { label: "Marathi Divorcee Brides in Mumbai" },
  { label: "Second Marriage Marathi Divorcee Vadhu" },
  { label: "Second Marriage Marathi Grooms" },
  { label: "Marathi Divorced Grooms" },
  { label: "Divorcee Matrimony Marathi Grooms" },
  { label: "Marathi Divorcee Matrimony" },
  { label: "Anand Maratha Divorcee Brides" },
  { label: "Marathi Divorcee Matrimony App" },
  { label: "Yog Maratha Divorcee Brides" },
  { label: "Second Marriage 45 age 96 Kuli Maratha Divorcee Brides" },
  { label: "Anand Maratha Divorcee Brides List" },
  { label: "Maratha Divorcee Brides" },
  { label: "Divorcee Matrimony Marathi" },
  { label: "Vadhu 45 age 96 Kuli Maratha Divorcee Brides" },
  { label: "Divorcee Vadhu" },
  { label: "Widow Marathi Divorcee Vadhu" },
  { label: "Second Marriage Marathi Divorcee Vadhu" },
  { label: "Second Marriage Marathi Girl" },
  { label: "Second Marriage Marathi Latest" },
  { label: "Marathi Divorced Matrimony" },
  { label: "Divorced Grooms in Pune for Marriage" },
];

export default function MarathiDivorceeMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी समाजातील घटस्फोटित वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_divorcee_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Divorcee Matrimony for Divorced grooms and brides"
        items={communityServices}
      />

    </div>
  );
}
